module.exports = __webpack_public_path__ + "assets/img/172-6C6D LaVille-v4-1.9a821dcc.jpg";